export enum UserSigningStatus {
    SIGNING_IN = 'SIGNING_IN',
    SIGNED = 'SIGNED',
    SIGNED_OUT = 'SIGNED_OUT'
}
